module.exports = __webpack_public_path__ + "static/media/new_logan_logo_white.6ea001ee.png";